import { ActionTree } from 'vuex'
import { processLocalizedURLAddress } from '@vue-storefront/core/helpers'
import { TaskQueue } from '@vue-storefront/core/lib/sync'
import getApiEndpointUrl from '@vue-storefront/core/helpers/getApiEndpointUrl'
import RootState from '@vue-storefront/core/types/RootState'
import config from 'config'

const STATUS_OK = 200
const APPLY_ENDPOINT = 'apply_endpoint'
const REMOVE_ENDPOINT = 'remove_endpoint'

const send = async ({ dispatch }, endpoint: string, code: string) => {
  const response = await TaskQueue.execute({
    url: processLocalizedURLAddress(getApiEndpointUrl(config.giftCard, endpoint)),
    silent: true,
    payload: {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      mode: 'cors',
      body: JSON.stringify({ code })
    }
  })

  if (response.code !== STATUS_OK) {
    const error: any = new Error(typeof response.result === 'string' ? response.result : 'Gift card request failed')
    error.code = response.code
    throw error
  }

  await dispatch('cart/syncTotals', { forceServerSync: true }, { root: true })

  return response
}

const actions: ActionTree<{}, RootState> = {
  applyCode (context, code: string) {
    return send(context, APPLY_ENDPOINT, code)
  },
  removeCode (context, code: string) {
    return send(context, REMOVE_ENDPOINT, code)
  }
}

export default actions
